import { render, staticRenderFns } from "./Mllist.vue?vue&type=template&id=406b047d&scoped=true"
import script from "./Mllist.vue?vue&type=script&lang=js"
export * from "./Mllist.vue?vue&type=script&lang=js"
import style0 from "./Mllist.vue?vue&type=style&index=0&id=406b047d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406b047d",
  null
  
)

export default component.exports